import { useEffect, useState } from "react";
import axios from "axios";

const url = 'https://computer-quiz-backend.herokuapp.com/quizzes';

export const useGetQuizzes = () => {
  const [quizzes, setQuizzes] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchQuizNames = async () => {
      try {
        const { data } = await axios.get(url, 
            {
                headers: { 'api-token': localStorage.getItem('token') }
            });
        setQuizzes(data);
      } catch (error) {
        setError(error.message);
      }
    };

    fetchQuizNames();
  }, []);

  return { quizzes, error };
};